import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleNodes } from "@fortawesome/pro-regular-svg-icons";
import { RWA_DATA_EMAIL_ADDRESS } from "~/consts";
import { Anchor } from "~/components/Anchor";
import { ConfidentialNetworkNotice } from "~/components/ConfidentialNetworkNotice";

// // // //

const CONFIDENTIAL_NETWORK_SLUGS = ["liquid-network"];

export function isConfidentialNetwork(
    networkSlug: string | undefined,
): boolean {
    return networkSlug
        ? CONFIDENTIAL_NETWORK_SLUGS.includes(networkSlug)
        : false;
}

// // // //

/**
 * Renders an empty state for AssetTokenHolders
 */
export function TokenHoldersEmptyState(props: {
    networkSlug?: string;
    networkName?: string;
}) {
    const { networkSlug, networkName } = props;

    if (isConfidentialNetwork(networkSlug)) {
        return (
            <ConfidentialNetworkNotice
                networkName={networkName ?? "this network"}
                context="holders"
            />
        );
    }

    return (
        <div
            className="relative w-full h-full flex flex-col justify-center items-center px-12 py-24 text-center text-slate-400"
            style={{ minHeight: "580px" }}
        >
            <FontAwesomeIcon
                className="mx-auto h-12 w-12"
                icon={faCircleNodes}
            />
            <p className="mt-4 block text-lg font-light">
                No holders data currently available
            </p>
            <p className="mt-4 block text-base font-light">
                Please check back later
            </p>

            <div className="flex items-center mt-2">
                <div className="grow h-px bg-slate-400 w-10" />
                <span className="px-4 text-sm font-light text-slate-400">
                    or
                </span>
                <div className="grow h-px bg-slate-400 w-10" />
            </div>

            <p className="mt-2 block text-base font-light">
                email us at{" "}
                <Anchor
                    href={`mailto:${RWA_DATA_EMAIL_ADDRESS}`}
                    analyticsLabel={`Token Holders Empty State - email ${RWA_DATA_EMAIL_ADDRESS}`}
                    className="underline underline-offset-4"
                    variant="default"
                >
                    {RWA_DATA_EMAIL_ADDRESS}
                </Anchor>{" "}
                to report missing or incorrect data
            </p>
        </div>
    );
}
